<template>
  <div class="provider-view">
    <div class="header-section">
      <div class="header-content">
        <div class="title-section">
          <h1 class="title">Provider Overview</h1>
          <span class="catalog-badge">Provider Workspace</span>
        </div>
      </div>
    </div>

    <section class="assets-section">
      <div class="policies-grid">
        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-database" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Connector Assets</h3>
              <div class="policy-type">Currently published</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-box"></i>
                Count
              </span>
              <span class="info-value">{{ providerAssetsCount }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-check-circle"></i>
                Health
              </span>
              <span class="info-value">{{ connectorHealth.assets }}</span>
            </div>
          </div>
        </div>

        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-shield" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Connector Policies</h3>
              <div class="policy-type">Active access rules</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-file"></i>
                Count
              </span>
              <span class="info-value">{{ policiesCount }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-check-circle"></i>
                Coverage
              </span>
              <span class="info-value">{{ connectorHealth.policies }}</span>
            </div>
          </div>
        </div>

        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-tag" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Connector Offers</h3>
              <div class="policy-type">Published contracts</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-briefcase"></i>
                Count
              </span>
              <span class="info-value">{{ offersCount }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-check-circle"></i>
                Status
              </span>
              <span class="info-value">{{ connectorHealth.offers }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="policies-grid">
        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-box" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Store Staging</h3>
              <div class="policy-type">Pre-publish workspace</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-database"></i>
                Assets in Store
              </span>
              <span class="info-value">{{ storeCounts.assets }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-shield"></i>
                Policies in Store
              </span>
              <span class="info-value">{{ storeCounts.policies }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-tag"></i>
                Offers Drafted
              </span>
              <span class="info-value">{{ storeCounts.offers }}</span>
            </div>
          </div>
        </div>

        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-flowchart" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Workflow Steps</h3>
              <div class="policy-type">Store to connector pipeline</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-pencil"></i>
                Drafting
              </span>
              <span class="info-value">{{ workflowSteps.drafting }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-check-circle"></i>
                Review
              </span>
              <span class="info-value">{{ workflowSteps.review }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-cloud-upload"></i>
                Ready to Publish
              </span>
              <span class="info-value">{{ workflowSteps.ready }}</span>
            </div>
          </div>
        </div>

        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-exclamation-triangle" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Attention Needed</h3>
              <div class="policy-type">Resolve before publish</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-times-circle"></i>
                Missing Policy Links
              </span>
              <span class="info-value">{{ attentionCounts.missingPolicy }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-times-circle"></i>
                Missing Assets
              </span>
              <span class="info-value">{{ attentionCounts.missingAsset }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-clock"></i>
                Pending Reviews
              </span>
              <span class="info-value">{{ attentionCounts.pendingReview }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="policies-grid">
        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-history" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Recent Activity</h3>
              <div class="policy-type">Latest workflow events</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-pencil"></i>
                Drafted Offer
              </span>
              <span class="info-value">Store Offer - Energy Snapshot</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-check-circle"></i>
                Policy Review
              </span>
              <span class="info-value">Partner Access Policy</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-cloud-upload"></i>
                Published Offer
              </span>
              <span class="info-value">Traffic Flow Offer</span>
            </div>
          </div>
        </div>

        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-chart-line" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Connector Momentum</h3>
              <div class="policy-type">Current cycle snapshot</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-sync"></i>
                Sync Status
              </span>
              <span class="info-value">{{ connectorHealth.sync }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-calendar"></i>
                Last Publish
              </span>
              <span class="info-value">{{ connectorHealth.lastPublish }}</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-bolt"></i>
                Publishing Window
              </span>
              <span class="info-value">{{ connectorHealth.window }}</span>
            </div>
          </div>
        </div>

        <div class="policy-card">
          <div class="policy-card-header">
            <div class="policy-badge">
              <i class="pi pi-compass" style="font-size: 1rem"></i>
            </div>
            <div class="policy-title-section">
              <h3 class="policy-id">Next Actions</h3>
              <div class="policy-type">Suggested workflow focus</div>
            </div>
          </div>
          <div class="policy-card-body">
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-angle-right"></i>
                Review store offers
              </span>
              <span class="info-value">2 awaiting approval</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-angle-right"></i>
                Attach policies
              </span>
              <span class="info-value">1 asset missing policy</span>
            </div>
            <div class="policy-info-item">
              <span class="info-label">
                <i class="pi pi-angle-right"></i>
                Publish to connector
              </span>
              <span class="info-value">Next window in 3h</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  providerAssets: {
    type: Array,
    default: () => [],
  },
  policies: {
    type: Array,
    default: () => [],
  },
  contractDefinitions: {
    type: Array,
    default: () => [],
  },
});

const providerAssetsCount = computed(() => props.providerAssets.length);
const policiesCount = computed(() => props.policies.length);
const offersCount = computed(() => props.contractDefinitions.length);

const connectorHealth = {
  assets: "All published",
  policies: "Coverage aligned",
  offers: "Stable",
  sync: "Healthy",
  lastPublish: "Today, 09:40",
  window: "Open",
};

const storeCounts = {
  assets: 4,
  policies: 3,
  offers: 2,
};

const workflowSteps = {
  drafting: 3,
  review: 2,
  ready: 1,
};

const attentionCounts = {
  missingPolicy: 1,
  missingAsset: 0,
  pendingReview: 2,
};
</script>

<style scoped src="../assets/provider-view.css"></style>
